import { ComponentKey } from "@certa/studio-core";

export const getParentComponentType = (componentType: ComponentKey) => {
  switch (componentType) {
    case ComponentKey.FIELDS:
      return ComponentKey.STEPS;
    case ComponentKey.STEPS:
      return ComponentKey.SWIMLANES;
    case ComponentKey.SWIMLANES:
      return ComponentKey.PROCESS;
    default:
      return null;
  }
};
